import { render, staticRenderFns } from "./PayrollView.vue?vue&type=template&id=4508d30a&scoped=true"
import script from "./PayrollView.vue?vue&type=script&lang=js"
export * from "./PayrollView.vue?vue&type=script&lang=js"
import style0 from "./PayrollView.vue?vue&type=style&index=0&id=4508d30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4508d30a",
  null
  
)

export default component.exports